"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSlider = void 0;
var _react = require("react");
var _useSwipe = require("./useSwipe");
const useSlider = params => {
  const {
    totalSlides,
    onScrollNext
  } = params;
  const containerRef = (0, _react.useRef)(null);
  const [currentSlide, setCurrentSlide] = (0, _react.useState)(0);
  // Максимальный индекс слайда, для которого отправили событие перелистывания слайда свайпом или кнопкой "Далее"
  const [maxSlideIndexShown, setMaxSlideIndexShown] = (0, _react.useState)(0);
  const scrollTo = (0, _react.useCallback)(index => {
    if (containerRef.current) {
      const slideWidth = containerRef.current.clientWidth;
      const translateX = -index * slideWidth;
      containerRef.current.style.transform = `translateX(${translateX}px)`;

      // Прокручиваем к верхней части слайдера после переключения
      const sliderElement = containerRef.current.parentElement?.parentElement?.parentElement;
      if (sliderElement) {
        sliderElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
      setCurrentSlide(index);
    }
  }, []);
  const showNextSlide = () => {
    const nextSlideIndex = currentSlide + 1;
    if (nextSlideIndex >= totalSlides) {
      return;
    }

    // Вызываем колбэк только если этот слайд ещё не был перелистнут ранее (т.е. его индекс больше максимального показанного)
    if (nextSlideIndex > maxSlideIndexShown) {
      onScrollNext?.();
      setMaxSlideIndexShown(nextSlideIndex);
    }
    scrollTo(nextSlideIndex);
  };
  const showPrevSlide = () => {
    if (currentSlide === 0) {
      return;
    }
    scrollTo(currentSlide - 1);
  };
  (0, _useSwipe.useSwipe)({
    onSwipeLeft: showNextSlide,
    onSwipeRight: showPrevSlide
  });
  return {
    containerRef,
    currentSlide,
    showNextSlide,
    showPrevSlide
  };
};
exports.useSlider = useSlider;